import { requestBuilder } from '../../../http/RequestBuilder';
import type { IncomeSplitExecution } from '../../entityTypes';

const useGetIncomeSplitExecutions = requestBuilder.query<
    IncomeSplitExecution[],
    { membershipId: string }
>({
    endpoint: ({ membershipId }) =>
        `/api/admin/money-map/${membershipId}/income-split-executions`,
    queryKey: ({ membershipId }) => `getIncomeSplitExecutions/${membershipId}`,
});

interface UseIncomeSplitExecutions {
    membershipId: string | null;
    executions: IncomeSplitExecution[] | undefined;
    isLoading: boolean;
    isError: boolean;
}

export const useIncomeSplitExecutions = (
    membershipId: string | null,
): UseIncomeSplitExecutions => {
    const {
        data: executions,
        isLoading,
        isError,
    } = useGetIncomeSplitExecutions(
        { membershipId: membershipId ?? '' },
        {
            enabled: membershipId != null,
        },
    );

    return {
        membershipId,
        executions,
        isLoading,
        isError,
    };
};
